export const navLinks = [
  { label: '首页', href: '/' },
  { label: '访问指引', href: '/category/access-guide' },
  { label: '最新公告', href: '/category/announcements' },
  { label: '使用教程', href: '/category/tutorials' },
  { label: '安全须知', href: '/category/security' },
  { label: '关于我们', href: '/about' },
];